import React from 'react';
import type { TEnrollProtocol } from '@besuites/auth/flow';
import AuthFlow from '@/components/auth/flow/Auth.Flow';
import useAuthFlow from '@/hooks/use.auth.flow';

type Props = {
    enroll: TEnrollProtocol | null;
    onDone: () => void;
    onCancel: () => void;
};

const StepUpPanel: React.FC<Props> = ({ enroll, onDone, onCancel }) => {
    const flow = useAuthFlow({ kind: 'step-up', onDone });
    const { start } = flow;
    const started = React.useRef(false);

    React.useEffect(() => {
        if (started.current) return;
        started.current = true;
        void start(null, enroll === null ? undefined : { enroll });
    }, [start, enroll]);

    return <AuthFlow flow={flow} onRestart={onCancel} newPasswordLabel="SALVA LA PASSWORD" />;
};

export default StepUpPanel;
